import React from "react";

export const BgTexture = () => {
  return (
    <>
      <div className="topo-bg" aria-hidden="true" />
      <div className="grain" aria-hidden="true" />
    </>
  );
};

export default BgTexture;
